import VerifyPhoneError from './VerifyPhoneError';
class InvalidPhoneToken extends VerifyPhoneError {
    constructor(options) {
        super('Received token is not the same as stored token', options);
    }
}
export default InvalidPhoneToken;
